import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {API} from '@chekin/api';

function useFetchDeals({reservationId}: {reservationId?: string}) {
  return useQuery({
    queryKey: [QUERY_CACHE_KEYS.deals, reservationId],
    queryFn: () =>
      API.upselling.getDeals(`reservation_id=${reservationId}&is_active=true`),
    enabled: Boolean(reservationId),
  });
}

export {useFetchDeals};
